import script from "./BabyNoteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BabyNoteModal.vue?vue&type=script&setup=true&lang=js"

import "./BabyNoteModal.vue?vue&type=style&index=0&id=3b001974&lang=css"

const __exports__ = script;

export default __exports__